import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { fmtRM, fmtDate } from "../../lib/format";
import { useLang } from "../../lib/i18n";
import { StatusBadge, Spinner } from "../../components/Shell";
import { Wallet, HandCoins, ReceiptText, UserCircle2 } from "lucide-react";

export default function Home() {
  const [data, setData] = useState(null);
  const { lang } = useLang();

  useEffect(() => {
    api.get("/portal/me").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <Spinner />;
  const { member, tenant } = data;

  const quick = [
    { to: "/portal/shares", icon: Wallet, label: lang === "bm" ? "Saham Koperasi" : "Cooperative Shares", testid: "quick-shares" },
    { to: "/portal/statements", icon: HandCoins, label: lang === "bm" ? "Yuran Bulanan" : "Monthly Fees", testid: "quick-fees" },
    { to: "/portal/statements", icon: ReceiptText, label: lang === "bm" ? "Resit & Penyata" : "Receipts & Statements", testid: "quick-receipts" },
  ];

  return (
    <div data-testid="portal-home" className="max-w-4xl mx-auto">
      <div className="rounded-2xl p-6 sm:p-8 text-white relative overflow-hidden" style={{ backgroundColor: tenant?.branding?.primary_color || "#0284C7" }}>
        <div className="flex items-start gap-4">
          <div className="w-14 h-14 rounded-full bg-white/15 flex items-center justify-center shrink-0">
            <UserCircle2 className="w-8 h-8 text-white/90" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-white/60">{tenant?.name}</div>
            <h1 className="font-display text-2xl font-bold mt-1">{member.name}</h1>
            <div className="mt-2 flex flex-wrap items-center gap-2">
              <span className="font-mono text-xs bg-white/15 rounded-full px-3 py-1">{member.member_no}</span>
              <StatusBadge status={member.status} />
              <StatusBadge status={member.kyc_status} />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 mt-8">
          <div className="bg-white/10 rounded-xl p-4 backdrop-blur">
            <div className="text-[10px] uppercase tracking-[0.15em] text-white/60">{lang === "bm" ? "Baki Saham" : "Share Balance"}</div>
            <div className="font-mono text-xl sm:text-2xl font-bold mt-1" data-testid="portal-share-balance">{fmtRM(member.share_balance)}</div>
          </div>
          <div className="bg-white/10 rounded-xl p-4 backdrop-blur">
            <div className="text-[10px] uppercase tracking-[0.15em] text-white/60">{lang === "bm" ? "Yuran Tertunggak" : "Fees Outstanding"}</div>
            <div className="font-mono text-xl sm:text-2xl font-bold mt-1" data-testid="portal-fee-balance">{fmtRM(member.fee_balance)}</div>
          </div>
        </div>
      </div>

      <div className="grid sm:grid-cols-3 gap-4 mt-6">
        {quick.map((q) => (
          <Link key={q.testid} to={q.to} data-testid={q.testid}
            className="bg-card rounded-xl border border-brand-deep/10 p-5 flex items-center gap-4 hover:shadow-md hover:border-gold/50 transition-all">
            <div className="w-11 h-11 rounded-xl bg-brand-light flex items-center justify-center shrink-0">
              <q.icon className="w-5 h-5 text-brand-deep" />
            </div>
            <span className="font-semibold text-sm text-brand-dark">{q.label}</span>
          </Link>
        ))}
      </div>

      <div className="mt-6 bg-card rounded-xl border border-brand-deep/10 p-5 text-sm text-muted-foreground">
        {lang === "bm" ? "Ahli sejak" : "Member since"}: <span className="font-semibold text-brand-dark">{fmtDate(member.joined_at)}</span>
        {tenant?.branding?.login_message && <span className="block mt-1 text-xs">{tenant.branding.login_message}</span>}
      </div>
    </div>
  );
}
